"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.createCustomStyles = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
var styles_1 = require("../Input/styles");
var createCustomStyles = function (_a) {
    var borderless = _a.borderless, justifyMenu = _a.justifyMenu;
    return ({
        container: function (_a, props) {
            var pointerEvents = _a.pointerEvents, styles = __rest(_a, ["pointerEvents"]);
            return (__assign(__assign({}, styles), { display: 'inline-block', cursor: props.isDisabled ? 'not-allowed' : undefined, pointerEvents: props.isDisabled ? 'all' : pointerEvents }));
        },
        control: function (styles, props) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, styles), { pointerEvents: props.isDisabled ? 'none' : undefined }), (_b = (_a = styles_1.designSystemInputThemeConfig.base) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.default), (props.isDisabled ? (_d = (_c = styles_1.designSystemInputThemeConfig.base) === null || _c === void 0 ? void 0 : _c.container) === null || _d === void 0 ? void 0 : _d.disabled : ({}))), (props.isFocused ? (_f = (_e = styles_1.designSystemInputThemeConfig.base) === null || _e === void 0 ? void 0 : _e.container) === null || _f === void 0 ? void 0 : _f.focused : ({}))), { ':hover': __assign({}, (_h = (_g = styles_1.designSystemInputThemeConfig.base) === null || _g === void 0 ? void 0 : _g.container) === null || _h === void 0 ? void 0 : _h.hovered) }), (borderless ? ({
                border: '1px solid transparent',
            }) : ({}))), { padding: 0, gap: 0 }));
        },
        placeholder: function (styles) {
            var _a, _b;
            return (__assign(__assign({}, styles), (_b = (_a = styles_1.designSystemInputThemeConfig.base) === null || _a === void 0 ? void 0 : _a.placeholder) === null || _b === void 0 ? void 0 : _b.default));
        },
        valueContainer: function (styles, props) { return (__assign(__assign({}, styles), { padding: '8px 12px', gap: 6, maxHeight: props.selectProps.menuIsOpen ? '340px' : '100px', overflow: 'overlay' })); },
        input: function (styles) { return (__assign(__assign({}, styles), { margin: 0, padding: 0 })); },
        indicatorSeparator: function (styles) { return (__assign(__assign({}, styles), { width: 16 })); },
        option: function (styles) { return (__assign(__assign({}, styles), { color: style_1.DesignSystemColor.Gray.DARK_4, padding: style_1.pxToRem(12.5) + " " + style_1.pxToRem(10) + " " + style_1.pxToRem(12.5) + " " + style_1.pxToRem(17.5), height: style_1.pxToRem(40), display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white', ':hover': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
            } })); },
        multiValue: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: style_1.SixsenseColor.White.DEFAULT, border: "1px solid " + style_1.DesignSystemColor.Gray.LIGHT_2, borderRadius: 6, padding: '1.5px 4px', paddingLeft: 4, margin: 0 })); },
        multiValueLabel: function (styles) { return (__assign(__assign({}, styles), { padding: 0 })); },
        multiValueRemove: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: 'transparent', color: style_1.DesignSystemThemeColor.Gray.LIGHT_1, cursor: 'pointer', ':hover': {
                backgroundColor: 'transparent',
            } })); },
        loadingIndicator: function (styles) { return (__assign(__assign({}, styles), { padding: 0 })); },
        clearIndicator: function (styles) { return (__assign(__assign({}, styles), { background: style_1.DesignSystemColor.Gray.LIGHT_1, color: 'white', borderRadius: '50%', padding: style_1.pxToRem(1), cursor: 'pointer', ':hover': {
                color: 'white',
            }, '& svg': {
                height: style_1.pxToRem(11),
                width: style_1.pxToRem(11),
            } })); },
        menu: function (styles) { return (__assign(__assign({}, styles), { width: justifyMenu === 'full' ? '100%' : 'auto', minWidth: '100%', right: justifyMenu === 'right' ? 0 : undefined })); },
        menuList: function (styles) { return (__assign(__assign({}, styles), { overflow: 'overlay' })); },
        menuPortal: function (styles) { return (__assign(__assign({}, styles), { zIndex: 200 })); },
    });
};
exports.createCustomStyles = createCustomStyles;
exports.styles = {
    selectContainer: react_1.css({
        width: '100%',
    }),
    selectLabel: react_1.css({
        color: style_1.SixsenseColor.Gray.DARK_2,
        fontSize: style_1.pxToRem(14),
        fontWeight: 400,
        marginBottom: style_1.pxToRem(6),
    }),
    helperText: react_1.css({
        color: style_1.SixsenseColor.Gray.DEFAULT,
        fontSize: style_1.pxToRem(14),
        fontWeight: 400,
        marginTop: style_1.pxToRem(8),
    }),
    label: react_1.css({
        marginLeft: style_1.pxToRem(8),
        color: style_1.SixsenseColor.Black.DEFAULT,
    }),
    subLabel: react_1.css({
        marginLeft: style_1.pxToRem(8),
        color: style_1.DesignSystemColor.Gray.DEFAULT,
    }),
};
